import { render, staticRenderFns } from "./userrole-component.vue?vue&type=template&id=ef57e15a"
import script from "./userrole-component.vue?vue&type=script&lang=ts"
export * from "./userrole-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports